import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import ComparisonHero from '../components/comparison/ComparisonHero';
import ComparisonTable from '../components/comparison/ComparisonTable';
import ComparisonDisclaimer from '../components/comparison/ComparisonDisclaimer';
import styles from './ComparisonPage.module.css';

// Public "RepBuddy vs the competition" page. Reuses the marketing nav/footer and owns
// its own scroll container (global `body { overflow: hidden }` for the app shell).
export default function ComparisonPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <ComparisonHero />
        <ComparisonTable />
        <ComparisonDisclaimer />
      </main>
      <LandingFooter />
    </div>
  );
}
